import { render, staticRenderFns } from "./MerchantUserNew.vue?vue&type=template&id=b108ca86&"
import script from "./MerchantUserNew.vue?vue&type=script&lang=ts&"
export * from "./MerchantUserNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports